import { MouseEvent } from "react";
import { Box } from "@mui/material";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import RCAUserWithAvatar from "pages/Corporate/RCA/components/RCAUserWithAvatar";
import RCAUsersDropdown from "pages/Corporate/RCA/components/RCAUsersDropdown";
import { useTranslation } from "react-i18next";
import { useActionPlanOwnerCell } from "./useActionPlanOwnerCell";

interface IActionPlanOwnerCellProps {
    row: IActionPlan;
}

const ActionPlanOwnerCell = ({ row }: IActionPlanOwnerCellProps) => {
    const { t } = useTranslation();
    const { isEditing, assigneeId, millId, handleAssigneeChange } = useActionPlanOwnerCell(row);

    if (isEditing) {
        return (
            <Box
                onClick={(event: MouseEvent<HTMLDivElement>) => {
                    event.stopPropagation();
                }}
                sx={{ width: "100%", minWidth: 0, display: "flex", justifyContent: "center" }}
            >
                <RCAUsersDropdown
                    fullWidth={false}
                    millId={millId ? String(millId) : ""}
                    multiple={false}
                    value={assigneeId}
                    onChange={handleAssigneeChange}
                    placeholder={t("rca.settings.owners_dropdown.select_owner")}
                />
            </Box>
        );
    }

    return (
        <RCAUserWithAvatar
            imageUrl={row.assignee?.media?.media_url || ""}
            name={`${row.assignee?.first_name} ${row.assignee?.last_name}`}
        />
    );
};

export default ActionPlanOwnerCell;
